import React, { FC } from 'react';
import { Modal as RootModal } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from '../../hooks/defaultHooks';
import selectors from '../../selectors';
import { closeModal } from '../../store/slices/modalSlice';
import ChangeUserPassword from './ChangeUserPassword';
import DeleteUser from './DeleteUser';
import LockUser from './lockUser';
import UnLockUser from './UnlockUser';
import UpdateRole from './UpdateRole';
import { getTheme } from '../../selectors/selectors';
import LockConsumer from './LockConsumer';
import UnLockConsumer from './UnLockConsumer';
import RestoreUser from './RestoreUser';
import MakeConsumerTransaction from './makeConsumerTransaction';
import AdjustConsumerTokens from './AdjustConsumerTokens';
import ExportLogs from './ExportLogs';
import ChangeMePassword from './ChangeMePassword';
import AddSecureIPs from './AddSecureIPs';
import ForgotPassword from './ForgotPassword/ForgotPassword';
import ConfirmInvoice from './ConfirmInvoice/ConfirmInvoice';
import CancelInvoice from './CancelInvoice/CancelInvoice';
import RestoreInvoice from './RestoreInvoice';
import DeleteFeatureModal from './DeleteFeatureModal';
import DownloadReportsModal from './DownloadReportsModal/DownloadReportsModal';
import SendInvoiceModal from './SendInvoiceModal/SendInvoiceModal';
import MakeInvoiceExpiredModal from './MakeInvoiceExpiredModal';
import DeleteAnnouncementModal from './DeleteAnnouncementModal';
import ActionWithSettings from './ActionWithSettings';
import DisableConsumer2FA from './DisableConsumer2FA';
import ActionWithTool from './ActionWithTool';
import ChangeToolImage from './ChangeToolImage';
import RejectReferralReward from './RejectReferralReward';

const mapping = {
  lockUser: LockUser,
  unLockUser: UnLockUser,
  updateRole: UpdateRole,
  changeMePassword: ChangeMePassword,
  addSecureIPs: AddSecureIPs,
  changeUserPassword: ChangeUserPassword,
  deleteUser: DeleteUser,
  lockConsumer: LockConsumer,
  unLockConsumer: UnLockConsumer,
  restoreUser: RestoreUser,
  forgotPassword: ForgotPassword,
  makeTransaction: MakeConsumerTransaction,
  adjustTokens: AdjustConsumerTokens,
  exportLogs: ExportLogs,
  confirmInvoice: ConfirmInvoice,
  cancelInvoice: CancelInvoice,
  restoreInvoice: RestoreInvoice,
  deleteFeatureModal: DeleteFeatureModal,
  downloadReportsModal: DownloadReportsModal,
  sendInvoiceModal: SendInvoiceModal,
  makeInvoiceExpiredModal: MakeInvoiceExpiredModal,
  deleteAnnouncementModal: DeleteAnnouncementModal,
  actionWithSettings: ActionWithSettings,
  disableConsumer2FA: DisableConsumer2FA,
  actionWithTool: ActionWithTool,
  changeToolImage: ChangeToolImage,
  rejectReferralReward: RejectReferralReward,
};

const Modal: FC = () => {
  const dispatch = useAppDispatch();
  const isOpened = useAppSelector(selectors.modalIsOpened);
  const theme = useAppSelector(getTheme);
  const modalType = useAppSelector(selectors.modalType);
  const ModalBody = mapping[modalType as keyof typeof mapping];
  const handleClose = () => {
    dispatch(closeModal());
  };
  if (modalType === 'updateTariff') {
    return (
      <RootModal
        show={isOpened}
        onHide={handleClose}
        centered
        data-testid="root-modal-body"
        size="xl"
      >
        {ModalBody && <ModalBody theme={theme} />}
      </RootModal>
    );
  }
  return (
    <RootModal show={isOpened} onHide={handleClose} centered data-testid="root-modal-body">
      {ModalBody && <ModalBody theme={theme} />}
    </RootModal>
  );
};

export default Modal;
